export default __webpack_public_path__ + "static/media/thumb.f2636632.gif";